module.exports = __webpack_public_path__ + "img/banner.7863f5d.png";